module.exports = __webpack_public_path__ + "img/联系我们首图.3c40621f.jpg";